import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { readCookieChoice, saveCookieChoice, startAnalytics, clearAnalyticsCookies } from "../lib/privacyConsent";

export const CookieConsent = () => {
  const [visible, setVisible] = useState(false);
  const [error, setError] = useState(false);
  useEffect(() => {
    const choice = readCookieChoice();
    if (choice === "accepted") startAnalytics();
    else clearAnalyticsCookies();
    setVisible(!choice);
    const open = () => setVisible(true);
    const sync = () => window.location.reload();
    window.addEventListener("fokeev:cookie-settings", open);
    const storage = (event) => { if (event.key === "fokeev_cookie_choice_v2") sync(); };
    window.addEventListener("storage", storage);
    return () => { window.removeEventListener("fokeev:cookie-settings", open); window.removeEventListener("storage", storage); };
  }, []);
  if (!visible) return null;
  const choose = (choice) => {
    if (saveCookieChoice(choice)) { setVisible(false); setError(false); }
    else setError(true);
  };
  return (
    <section aria-label="Настройки cookies" data-testid="cookie-consent-banner" className="fixed bottom-0 left-0 right-0 z-50 p-4">
      <div className="max-w-4xl mx-auto rounded-xl border border-[#d8d1c5] bg-[#F1EDE4] p-5 shadow-xl text-[#292929]">
        <p className="text-sm leading-relaxed">Разрешить cookies Яндекс Метрики для статистики посещений? <Link to="/privacy-policy" className="underline">Подробнее</Link></p>
        <div className="mt-4 flex flex-wrap gap-3">
          <button type="button" onClick={() => choose("rejected")} className="px-4 py-2 border border-[#51694e] rounded-lg" data-testid="cookie-reject-button">Без аналитики</button>
          <button type="button" onClick={() => choose("accepted")} style={{ color: "#fff" }} className="px-4 py-2 bg-[#51694e] text-white rounded-lg" data-testid="cookie-accept-button">Разрешить аналитику</button>
        </div>
        {error && <p role="alert" className="mt-2 text-sm">Браузер не позволяет сохранить выбор. Аналитика остаётся отключённой.</p>}
      </div>
    </section>
  );
};
export default CookieConsent;
